import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { isType } from '@sorare/core/src/lib/gql';

import type { UseBestBidBelongsToUser_bestBid } from './__generated__/useBestBidBelongsToUser.graphql.ts';

export const useBestBidBelongsToUser = () => {
  const { currentUser } = useCurrentUserContext();

  return (bestBid?: Nullable<UseBestBidBelongsToUser_bestBid>) => {
    return (
      currentUser &&
      bestBid?.bidder &&
      isType(bestBid.bidder, 'User') &&
      currentUser.slug === bestBid.bidder.slug
    );
  };
};

useBestBidBelongsToUser.fragments = {
  bestBid: gql`
    fragment UseBestBidBelongsToUser_bestBid on TokenBid {
      id
      bidder: userBidder {
        slug
      }
    }
  ` as TypedDocumentNode<UseBestBidBelongsToUser_bestBid>,
};
